import React, { memo, useCallback, useMemo, useState } from 'react'

import { Button } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import { datePublishedFiltersConfig } from 'Pods/SearchPage/Shared/DatePublishedContent/constants'
import DatePublishedContent from 'Pods/SearchPage/Shared/DatePublishedContent/DatePublishedContent'
import longestLabel from 'Pods/SearchPage/Shared/longestLabel'
import useTranslate from 'Pods/SearchPage/Shared/useTranslate'
import { clearDatePublished } from 'Pods/SearchPage/Store/actions/datePublished'
import { DATE_PUBLISHED } from 'Pods/SearchPage/Store/constants'
import { useSearchPageStore } from 'Pods/SearchPage/Store/index'
import FiltersWrapper from 'Pods/Shared/FiltersWrapper/FiltersWrapper'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'


// All Time is the default, so it never shows as a value.
const DATE_OPTIONS = datePublishedFiltersConfig[0].filters.filter(filter => filter.value !== DATE_PUBLISHED.ALL_TIME)

function DatePublished() {
  const translate = useTranslate()

  const datePublished = useSearchPageStore(state => state.datePublished ?? DATE_PUBLISHED.ALL_TIME)
  const [triggerCloseDropdown, setTriggerCloseDropdown] = useState(false)

  const hasSelectedAnyFilter = datePublished !== DATE_PUBLISHED.ALL_TIME

  const reservedValue = useMemo(() => longestLabel(
    DATE_OPTIONS.map(option => translate(`search_page.filters.date_published.short.${option.labelKey}`)),
  ), [translate])

  const selectedValues = useMemo(() => {
    const option = DATE_OPTIONS.find(filter => filter.value === datePublished)

    return hasSelectedAnyFilter && option
      ? [translate(`search_page.filters.date_published.short.${option.labelKey}`)]
      : EMPTY_ARRAY
  }, [datePublished, hasSelectedAnyFilter, translate])

  const handleReset = useCallback(() => {
    clearDatePublished()
  }, [])

  // Applying a custom range is a committing action, so the dropdown steps out of the way and
  // leaves the filtered results visible.
  const handleApply = useCallback(() => {
    setTriggerCloseDropdown(true)
  }, [])

  const content = useMemo(() => (
    <>
      <DatePublishedContent onApply={handleApply} />
      <Button
        type="ghost"
        size="tiny"
        customClass="filter-wrapper__reset-button"
        onClick={handleReset}
        disabled={!hasSelectedAnyFilter}
      >
        {translate('search_page.filters.more_filters.reset')}
      </Button>
    </>
  ), [handleApply, handleReset, hasSelectedAnyFilter])

  return (
    <FiltersWrapper
      trailIconSize="small"
      placeholder={translate('search_page.filters.date_published.title')}
      content={content}
      hasSelectedAnyFilters={hasSelectedAnyFilter}
      selectedValues={selectedValues}
      reservedValue={reservedValue}
      triggerCloseDropdown={triggerCloseDropdown}
      setTriggerCloseDropdown={setTriggerCloseDropdown}
      closingDropdownClassName="filter-wrapper"
    />
  )
}

export default memo(DatePublished)
